<script setup>
/**
 * DemandForm - Main form component that allows users to select between
 * a simple contact form or a detailed service request form.
 *
 * This component re-exports FormSelector for backward compatibility.
 */
import FormSelector from '@/components/FormSelector.vue'

defineProps({
    services: {
        type: Array,
        required: true,
    },
})
</script>

<template>
    <FormSelector :services="services" />
</template>
